<script lang="ts">
  import { navigationLoading } from '@/stores/navigationLoading'
</script>

<span
  role="status"
  class="inline-flex size-5 shrink-0 items-center justify-center text-neutral-500 dark:text-gray-400"
>
  {#if $navigationLoading}
    <span
      aria-hidden="true"
      class="size-3.5 rounded-full border-2 border-current border-r-transparent motion-safe:animate-spin"
    ></span>
    <span class="sr-only">Loading page</span>
  {/if}
</span>
